import {MetaAction} from '../../actions/types';
import {findMatchInEnum} from '../helper';
import {invalidActionType, ErrorAction} from '../Error';
import {validationError as historyValidationError} from './History/actions';
import {ActionType as HistoryActionType} from './History/types';

import {validationError as redirectValidationError} from './Redirect/actions';
import {ActionType as RedirectActionType} from './Redirect/types';

export default function validationError(action: MetaAction): undefined | ErrorAction {
  if (findMatchInEnum(RedirectActionType, action.type)) {
    return redirectValidationError(action);
  }
  if (findMatchInEnum(HistoryActionType, action.type)) {
    return historyValidationError(action);
  }

  return invalidActionType(action);
}



// WEBPACK FOOTER //
// ./src/actions/Navigation/validator.ts